import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Box from '@nubank/nuds-web/components/Box/Box';

import FeesTable from 'patterns/FeesTable/FeesTable';

function SectionFees({
  className,
  children,
}) {
  return (
    <Box
      backgroundColor="white"
      paddingVertical={{ xs: '16x', md: '24x', lg: '32x' }}
      paddingHorizontal={{ xs: '4x', md: '2.5rem', lg: '10.625rem' }}
      className={className}
    >
      <Box marginBottom="12x">
        {children}
      </Box>
      <FeesTable />
    </Box>
  );
}

SectionFees.defaultProps = {
  children: undefined,
  className: undefined,
};

SectionFees.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default memo(SectionFees);
